import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isAuthImage'
})
export class IsAuthImagePipe implements PipeTransform {
  constructor(private http: HttpClient) {}

  /**
   * Load an image via http.
   * @example //How to use it:
   * <img [src]="obj.link | isAuthImage | async" />
   */
  async transform(src: string): Promise<string> {
    const imageBlob = await this.http
      .get(src, { responseType: 'blob' })
      .toPromise();
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(imageBlob);
    });
  }
}
